import { AnalyticsSummaryCardProps } from './AnalyticsSummaryCard.types';

// This object should contain a mock value for each required prop of this component
export const requiredProps: AnalyticsSummaryCardProps = {
  value: '',
  chartData: [
    {
      label: new Date(),
      value: 0,
    },
  ],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as AnalyticsSummaryCardProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      percentage: 0,
    } as AnalyticsSummaryCardProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
